import React, {createContext, useEffect, useState} from 'react';
import LobbyModalContainer from "../common/lobby_modal_container";
import {CasinoImageInterface} from "../../data/gameData_casino";
import {SlotImageInterface} from "../../data/gameData_slot";
import swal from "sweetalert";

export type gameType = "casino" | "slot"
export type vendorSum = CasinoImageInterface | SlotImageInterface
interface LobbyInterface {
    SetLobbyShow: () => void
    SetVendorInfo: (thisVendor: vendorSum) => void
    SetType: (thisType: gameType) => void
}

export const lobbyModalContext = createContext<LobbyInterface>({
    SetLobbyShow: () => {},
    SetVendorInfo: (thisVendor: vendorSum) => {},
    SetType: (thisType: gameType) => {}
})
function LobbyModalProvider({children}: {children: React.ReactNode}) {
    const [lobbyShow, setLobbyShow] = useState<boolean>(false)
    const [vendor, setVendor] = useState<vendorSum | undefined>()
    const [type, setType] = useState<gameType>("slot")
    function SetLobbyShow(){
        setLobbyShow(true)
    }
    function SetVendorInfo(thisVendor: vendorSum){
        setVendor(thisVendor)
    }
    function SetType(thisType: gameType){
        setType(thisType)
    }
    return (
        <lobbyModalContext.Provider value={{SetLobbyShow, SetVendorInfo, SetType}}>
            {children}
            <LobbyModalContainer show={lobbyShow} setShow={setLobbyShow} vendor={vendor as vendorSum} type={type}/>
        </lobbyModalContext.Provider>
    );
}

export default LobbyModalProvider;